import {required} from "vuelidate/lib/validators";  
const menutranslations = {
    data() { 
      return {   
        menutranslationsData: {  
          Title: "", 
          Link: "",   
          Langid: null, 
          Menuid: null, 
          Websiteid: null, 
          }, 
  
          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('menus.AddEdit.Title')},  
            Link:{FieldName:"Link",Field:"input",FieldTitle:this.$t('menus.AddEdit.Link')},  
            } 
      }
    },  
    validations:{ 
      FormData: {  
        Title: {required},   
        Link: {required},   

      }
 
  },
  created(){ 
  }
}
export default menutranslations